export const REPORT_STATUS = {
  IN_PROGRESS: "IN_PROGRESS",
  READY: "READY",
  FAILED: "FAILED",
  NO_RECORDS: "NO_RECORDS",
};

// reportRequestType says which kind of report a row is, and so which link
// field it will eventually carry.
export const isPerformanceReport = (report) => report?.reportRequestType === "PERFORMANCE";

export const getReportLink = (report) =>
  isPerformanceReport(report) ? report?.performanceCycleReport : report?.reportLink;

// reportFailed must be checked first. reportAvailable is deliberately ignored:
// it is true while a report is still generating, so it can't tell
// "in progress" apart from "failed".
export const getReportStatus = (report) => {
  if (report?.reportFailed) return REPORT_STATUS.FAILED;
  // The filters matched nothing -- finished, but not a failure.
  if (report?.isNoRecordsFound) return REPORT_STATUS.NO_RECORDS;
  if (getReportLink(report)) return REPORT_STATUS.READY;
  return REPORT_STATUS.IN_PROGRESS;
};

export const isReportInProgress = (report) =>
  getReportStatus(report) === REPORT_STATUS.IN_PROGRESS;
